import { render, staticRenderFns } from "./CompareItem.vue?vue&type=template&id=bca37498&scoped=true&"
import script from "./CompareItem.vue?vue&type=script&lang=js&"
export * from "./CompareItem.vue?vue&type=script&lang=js&"
import style0 from "./CompareItem.vue?vue&type=style&index=0&id=bca37498&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca37498",
  null
  
)

export default component.exports